<template>
  <div class="relative z-modal">
    <Transition name="fade">
    <rules-modal
        :type="currentModalTab === 'reward' ? 'reward' : 'all'"
        v-if="currentModalTab === 'rules' || currentModalTab === 'reward'"
                 @close="closeModal">
    </rules-modal>
    </Transition>
  </div>
  <div class="grid grid-cols-1 gap-x-6 gap-y-3 xl:grid-cols-[929px_1fr]">
    <div class="-mx-3">
      <div class="px-5 py-5" v-if="window.size.mobile">
        <MainPrize />
      </div>
      <div v-if="window.size.mobile"
           id="sticky-swiper"
           ref="statsFilter"
           :class="{ 'shadow-zt' : isFilteringSticky, '!z-0 border-t' : !isFilteringSticky  }"
           class="flex gap-x-2.5 bg-[#1F2733] z-[888] px-2.5 sticky top-0 py-[11px] text-xs font-medium border-zt-light">
        <div
            @click="changeBlock('table')"
            :class="{ 'bg-zt-light' : currentBlock === 'table' }"
            class="py-[6px] px-[11px] transition-colors rounded-[500px] border border-zt-light">
          Klasyfikacja
        </div>
        <div
            @click="changeBlock('rewards')"
            :class="{ 'bg-zt-light' : currentBlock === 'rewards' }"
            class="py-[6px] px-[11px] transition-colors rounded-[500px] border border-zt-light">
          Nagrody
        </div>
      </div>
      <div ref="table">
        <Rankings :year="+year" :month="+month" is-month-rank />
      </div>
      <div
          @click="currentModalTab = 'rules'"
          class="h-[60px] zt-hover cursor-pointer mt-4 justify-between bg-zt-light/35 border border-zt-light rounded-zt flex items-center px-[18px] mx-[16px] xl:mx-0">
        <div class="flex items-center gap-x-[13px]">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="23" viewBox="0 0 25 23" fill="none">
            <g clip-path="url(#clip0_43222_133300)">
              <path d="M20.4413 0.273438H3.86676C3.50904 0.273438 3.21094 0.631161 3.21094 1.0485V21.4984C3.21094 21.9157 3.50904 22.2734 3.86676 22.2734H20.4413C20.799 22.2734 21.0971 21.9157 21.0971 21.4984V1.0485C21.0971 0.631161 20.799 0.273438 20.4413 0.273438ZM6.66893 3.9103H10.7827C11.2597 3.9103 11.6175 4.32764 11.6175 4.86422C11.6175 5.40081 11.2597 5.81815 10.7827 5.81815H6.66893C6.19197 5.81815 5.83424 5.40081 5.83424 4.86422C5.83424 4.32764 6.25159 3.9103 6.66893 3.9103ZM6.66893 8.38184H10.7827C11.2597 8.38184 11.6175 8.79921 11.6175 9.33576C11.6175 9.87237 11.2597 10.2897 10.7827 10.2897H6.66893C6.19197 10.2897 5.83424 9.87237 5.83424 9.33576C5.83424 8.85883 6.25159 8.38184 6.66893 8.38184ZM16.8044 19.352H6.66893C6.19197 19.352 5.83424 18.9347 5.83424 18.3981C5.83424 17.8615 6.19197 17.4442 6.66893 17.4442H16.7448C17.2218 17.4442 17.5795 17.8615 17.5795 18.3981C17.6392 18.9347 17.2218 19.352 16.8044 19.352ZM16.8044 14.8208H6.66893C6.19197 14.8208 5.83424 14.4035 5.83424 13.8669C5.83424 13.3304 6.19197 12.913 6.66893 12.913H16.7448C17.2218 12.913 17.5795 13.3304 17.5795 13.8669C17.6392 14.4035 17.2218 14.8208 16.8044 14.8208ZM17.7583 9.03763C17.7583 9.455 17.4603 9.81275 17.1025 9.81275H14.4792C14.1215 9.81275 13.8234 9.455 13.8234 9.03763V4.86422C13.8234 4.44688 14.1215 4.08916 14.4792 4.08916H17.1025C17.4603 4.08916 17.7583 4.44688 17.7583 4.86422V9.03763Z" fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_43222_133300">
                <rect width="24.3571" height="22" fill="white" transform="translate(0 0.273438)"/>
              </clipPath>
            </defs>
          </svg>
          <span class="text-medium">Zasady punktacji</span>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 14" fill="none">
          <path d="M0.304687 12.2459L4.44391 7.27345L0.304687 2.30094L1.57898 0.773436L7.00155 7.27345L1.57899 13.7734L0.304687 12.2459Z" fill="white"/>
        </svg>
      </div>

      <div class="pt-5">
        <span ref="rewards" class="text-xl font-semibold pl-4 xl:pl-0">
          Nagrody
        </span>

        <div
            @click="currentModalTab = 'reward'"
            class="h-[60px] zt-hover cursor-pointer mt-2.5 justify-between bg-zt-light/35 border border-zt-light rounded-zt flex items-center px-[18px] mx-[16px] xl:mx-0">
          <div class="flex items-center gap-x-[13px]">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 22 24" fill="none">
              <g clip-path="url(#clip0_43260_128407)">
                <path d="M9.71309 13.0156C7.82545 13.0156 2.27956 13.0156 2.27956 13.0156C1.69454 13.0156 1.21094 13.5007 1.21094 14.0875V22.1468C1.21094 22.7336 1.69454 23.2187 2.27956 23.2187C2.27956 23.2187 7.94245 23.2187 9.83795 23.2187C10.0875 23.2187 10.0875 22.9449 10.0875 22.9449V13.3833C10.0875 13.3833 10.0875 13.0156 9.71309 13.0156Z" fill="white"/>
                <path d="M19.7025 13.0156C19.7025 13.0156 14.1332 13.0156 12.2768 13.0156C11.8244 13.0156 11.8946 13.4851 11.8946 13.4851V22.9605C11.8946 22.9605 11.8946 23.2265 12.1598 23.2265C14.0474 23.2265 19.7025 23.2265 19.7025 23.2265C20.2876 23.2265 20.7711 22.7414 20.7711 22.1546V14.0954C20.7711 13.5007 20.2876 13.0156 19.7025 13.0156Z" fill="white"/>
                <path d="M10.0856 6.67244C10.0856 6.67244 10.0856 6.30469 9.72679 6.30469C7.58179 6.30469 1.06862 6.30469 1.06862 6.30469C0.483611 6.30469 0 6.78981 0 7.37665V10.7255C0 11.3124 0.483611 11.7974 1.06862 11.7974C1.06862 11.7974 7.613 11.7974 9.758 11.7974C10.0856 11.7974 10.0856 11.508 10.0856 11.508V6.67244Z" fill="white"/>
                <path d="M20.9115 6.3125C20.9115 6.3125 14.3984 6.3125 12.2222 6.3125C11.8945 6.3125 11.8945 6.62548 11.8945 6.62548V11.5314C11.8945 11.5314 11.8945 11.8131 12.3002 11.8131C14.453 11.8131 20.9115 11.8131 20.9115 11.8131C21.4965 11.8131 21.9802 11.328 21.9802 10.7411V7.38446C21.9802 6.79762 21.4965 6.3125 20.9115 6.3125Z" fill="white"/>
                <path d="M6.44325 5.51583C5.95184 5.51583 5.50723 5.47671 5.11722 5.39847C4.1188 5.20285 3.43238 4.81946 3.02677 4.24044C2.66016 3.71621 2.54316 3.06678 2.69136 2.31562C2.94097 1.00111 3.82239 0.273438 5.16402 0.273438C5.44483 0.273438 5.76464 0.304735 6.09224 0.375156C6.93466 0.539469 8.01885 1.02458 8.97828 1.67402C10.6163 2.76945 10.6943 3.458 10.6163 3.87269C10.4993 4.49083 9.92214 4.929 8.86914 5.2185C8.15149 5.40629 7.27006 5.51583 6.44325 5.51583ZM5.16402 1.99482C4.64141 1.99482 4.46201 2.14349 4.3684 2.64425C4.2904 3.05895 4.3918 3.19979 4.42301 3.24674C4.56341 3.44235 4.92221 3.60666 5.44483 3.70838C5.72564 3.76315 6.06884 3.79445 6.44325 3.79445C7.27006 3.79445 7.98771 3.66926 8.47128 3.53624C8.50249 3.52842 8.55706 3.48147 8.50249 3.45017C7.87849 2.93376 6.72406 2.2452 5.76464 2.05742C5.53843 2.01829 5.34342 1.99482 5.16402 1.99482Z" fill="white"/>
                <path d="M15.5601 5.51583C14.7333 5.51583 13.8519 5.40629 13.1421 5.21068C12.0813 4.92117 11.5118 4.483 11.3948 3.86487C11.3168 3.45017 11.3948 2.76162 13.0329 1.66619C14.0001 1.01676 15.0765 0.531645 15.919 0.367331C16.2388 0.304735 16.5508 0.273438 16.8394 0.273438C18.181 0.273438 19.0624 1.00111 19.3198 2.31562C19.468 3.06678 19.351 3.71621 18.9844 4.24044C18.571 4.82728 17.8846 5.21068 16.894 5.39847C16.4962 5.47671 16.0515 5.51583 15.5601 5.51583ZM13.5087 3.44235C13.4541 3.47365 13.4775 3.52842 13.5087 3.53624C13.9923 3.67709 14.7255 3.80228 15.5523 3.80228C15.9268 3.80228 16.27 3.77098 16.5508 3.71621C17.0734 3.61448 17.4322 3.45017 17.5726 3.25456C17.6038 3.20761 17.7052 3.06678 17.6272 2.65207C17.5258 2.15131 17.3464 2.00264 16.8315 2.00264C16.66 2.00264 16.4572 2.02612 16.231 2.06524C15.2793 2.2452 14.1405 2.92593 13.5087 3.44235Z" fill="white"/>
              </g>
              <defs>
                <clipPath id="clip0_43260_128407">
                  <rect width="22" height="23" fill="white" transform="translate(0 0.273438)"/>
                </clipPath>
              </defs>
            </svg>
            <span class="text-medium">Jak odebrać nagrodę?</span>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 14" fill="none">
            <path d="M0.304687 12.2459L4.44391 7.27345L0.304687 2.30094L1.57898 0.773436L7.00155 7.27345L1.57899 13.7734L0.304687 12.2459Z" fill="white"/>
          </svg>
        </div>
      </div>

      <div class="bg-zt-normal flex justify-center mt-4 border-zt-light border-y xl:rounded-zt xl:border-x">
        <div class="w-full xl:w-[623px]">
          <Prizes :show-close-window-button="false"/>
        </div>
      </div>

      <div>
        <Comments />
      </div>

    </div>
    <div v-if="window.size.desktop" class="w-full pb-4">
      <div
          :class="window.PHP.visibleAdminBar ? 'top-[110px]' : 'top-[80px]'"
          class="sticky xl:mt-[16px]">
        <DailyBetsProfile/>
      </div>
    </div>
  </div>

</template>

<script>
import { defineAsyncComponent } from 'vue';
import DailyBetsProfile from "../../sections/DailyBetsProfile.vue";
import Rankings from "../daily_bets_tabs/Rankings.vue";
import Prizes from "../daily_bets_tabs/Prizes.vue";
import MainPrize from "./MainPrize.vue";
import utils_mixin from "../../mixins/utils_mixin";
import Comments from "../Comments.vue";

export default {
  name: 'RankingTable',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    Comments,
    MainPrize,
    Prizes,
    Rankings,
    DailyBetsProfile,
    RulesModal: defineAsyncComponent(() => import('../modals/RulesModal.vue')),
    PrizeModal: defineAsyncComponent(() => import('../modals/PrizesModal.vue')),
  },
  data() {
    this.month = this.$attrs.miesiac ?? 7;
    this.year = this.$attrs.rok ?? 2022;
    return {
      rankingHistory: [],
      weekRank: [],
      currentModalTab: '',
      pointRankCount: 20,
      accuracyRankCount: 20,
      weekRankCount: 20,
      sortAccuracyColumn: 'accuracy',
      sortAccuracyAscending: 0, // 0 - malejąco, 1 - rosnąco
      sortPointsColumn: 'points',
      sortPointsAscending: 0,
      sortWeekColumn: 'accuracy',
      sortWeekAscending: 0,
      selectedUser: null,
      currentBlock: 'table',
      isFilteringSticky: false,
      rewardsPosition: 0
    }
  },
  mounted() {
    if (window.size.mobile) {
      this.emitter.on('update:rankingHeight', () => {
        setTimeout(() => {
          this.rewardsPosition = this.$refs.rewards.getBoundingClientRect().top + window.scrollY - 100;
        }, 500);
      });
      this.stickyFollowHeader('sticky-swiper', this.WP.user.adminBar);
      this.observeStatsFilter();
      setTimeout(() => {
        this.rewardsPosition = this.$refs.rewards.getBoundingClientRect().top + window.scrollY - 100;
        this.scrollEventListener();
      }, 1000);
    }
  },
  methods: {
    scrollEventListener() {
      window.addEventListener('scroll', () => {
        const currentScrollPos = window.scrollY;
        if (currentScrollPos >= this.rewardsPosition) {
          this.currentBlock = 'rewards';
        } else {
          this.currentBlock = 'table';
        }
      });
    },
    observeStatsFilter() {
      const stickyObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.intersectionRatio < 1) {
                this.isFilteringSticky = true;
              }
            });
          },
          {
            threshold: 1,
            rootMargin: `${WP.user.adminBar ? '-32' : '0'}px 0px 0px 0px`,
          }
      );
      const staticObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach(entry => {
              if (entry.intersectionRatio >= 1) {
                this.isFilteringSticky = false;
              }
            });
          },
          {
            threshold: 1,
            rootMargin: `${WP.user.adminBar ? '-98' : '-66'}px 0px 0px 0px`,
          }
      );
      staticObserver.observe(this.$refs.statsFilter);
      stickyObserver.observe(this.$refs.statsFilter);
    },
    changeBlock(block) {
      this.currentBlock = block;
      if (block === 'rewards') {
        const posY = this.$refs.rewards.getBoundingClientRect().top + window.scrollY - (this.WP.user.adminBar ? 90 : 60);
        window.scrollTo({
          top: posY,
          behavior: 'smooth'
        });
      } else {
        const posY = this.$refs.table.getBoundingClientRect().top + window.scrollY - (this.WP.user.adminBar ? 150 : 100);
        window.scrollTo({
          top: posY,
          behavior: 'smooth'
        });
      }
    },
    openModal(modalName) {
      this.currentModalTab = modalName;
    },
    closeModal() {
      this.currentModalTab = '';
    },
  }
}
</script>

<style scoped>

/* Handle */
.table-scroll::-webkit-scrollbar-thumb {
  display: none;
}

.table-scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.sort-by-asc
{
  left: 2px;
  display: inline-block;
  width: 0;
  height: 0;
  border: solid 5px transparent;
  background: transparent;
  border-bottom: solid 7px #FFFFFF;
  border-top-width: 0;
}

.sort-by-desc
{
  left: 2px;
  display: inline-block;
  width: 0;
  height: 0;
  border: solid 5px transparent;
  background: transparent;
  border-top: solid 7px #FFFFFF;
  border-bottom-width: 0;
}

.custom-text:before {
  @apply bg-zt-red;
  content: '';
  position: absolute;
  width: 3px;
  height: 60%;
  top: 2px;
  transform: translate(-0.5rem, 0.2em);
}

.left-mark:before {
  @apply content-[''] absolute top-1/2 left-0 rounded-zt w-[5px] h-[40px] -translate-y-1/2;
}

@media only screen and (min-width: 1280px) {

  .sort-by-asc
  {
    left: 5px;
  }

  .sort-by-desc
  {
    left: 5px;
  }

  .custom-text:before {
    transform: translate(-0.75rem, 0.2em);
    top: 4px;
  }
}

  .fade-enter-active,
  .fade-leave-active {
    z-index: 10;
    transition: all 0.3s ease-out;
  }

  .fade-enter-from,
  .fade-leave-to {
    z-index: 10;
    opacity: 0;
  }

</style>